"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const offline_query_resolver_1 = __importDefault(require("./offline-query-resolver"));
const cXTupleI18nDomainMappingV2_1 = require("@amzn/cxtuple-i18n-domain-mapping-typescript/dist/cXTupleI18nDomainMappingV2");
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const documents_json_1 = require("@amzn/cxtuple-i18n-domain-mapping-config/dist/acs_CXTupleI18nDomainMappingV2/documents.json");
const queries_json_1 = require("@amzn/cxtuple-i18n-domain-mapping-config/dist/acs_CXTupleI18nDomainMappingV2/queries.json");
/**
 * Resolves queries using the CXTupleI18nDomainMapping feature
 * (https://console.harmony.a2z.com/acs-web-editor/features/CXTupleI18nDomainMapping/).
 */
class CXTupleToI18nDomainQueryResolver extends offline_query_resolver_1.default {
    resolve(attributeName, args) {
        this.validate(attributeName, args);
        return this.doResolve(attributeName, args);
    }
    doResolve(attributeName, args) {
        const context = this.createAcsInput(args);
        const configBuilder = new i18n_configuration_provider_1.I18nConfiguration.Builder();
        switch (attributeName) {
            case i18n_configuration_provider_1.CXTupleToI18nDomain.I18N_DOMAIN:
                const i18nDomain = this.getAcsClient().getI18nDomain(context);
                configBuilder.addConfiguration(i18n_configuration_provider_1.CXTupleToI18nDomainResult.I18N_DOMAIN, i18nDomain);
                break;
            default:
                throw new Error(`Attribute name ${attributeName} is not defined for feature ${attributeName.getConfigType()}`);
        }
        return configBuilder.build();
    }
    getTypeSafeClientProvider() {
        return new cXTupleI18nDomainMappingV2_1.CXTupleI18nDomainMappingV2ClientProvider();
    }
    getOfflineConfigFiles() {
        return {
            documents: documents_json_1.documents,
            exactQueries: queries_json_1.queries
        };
    }
    getTargetConfigType() {
        return CXTupleToI18nDomainQueryResolver.CONFIG_TYPE;
    }
    getValidationErrorMessage() {
        return `CXTuple to I18nDomain mappings can only be resolved for configType ${CXTupleToI18nDomainQueryResolver.CONFIG_TYPE}`;
    }
    getAcsClient() {
        return super.acsClient;
    }
    createAcsInput(args) {
        if ((0, i18n_configuration_provider_1.isNullOrUndefined)(args.cxFamily)) {
            throw new Error('Missing required input CXFamily');
        }
        if ((0, i18n_configuration_provider_1.isNullOrUndefined)(args.cxId)) {
            throw new Error('Missing required input CXId');
        }
        return new cXTupleI18nDomainMappingV2_1.CXTupleI18nDomainMappingV2Context(args.cxFamily, args.cxId, args.cxProgram);
    }
}
exports.default = CXTupleToI18nDomainQueryResolver;
CXTupleToI18nDomainQueryResolver.CONFIG_TYPE = i18n_configuration_provider_1.ConfigType.CX_TUPLE_TO_I18N_DOMAIN;
//# sourceMappingURL=cx-tuple-to-i18n-domain-query-resolver.js.map